import * as tslib_1 from "tslib";
import { OnChanges, OnInit, EventEmitter, SimpleChanges } from '@angular/core';
import { msg } from 'src/app/constants/msg';
export class CompanyPresentationSectionComponent {
    constructor(alert) {
        this.alert = alert;
        this.selectedFile = null;
        this.selectedFileChange = new EventEmitter();
        this.submitPresentation = new EventEmitter();
        this.existingPresentationUrl = null;
        this.existingPresentationFileName = null;
        this.removeExistingPresentation = false;
        this.maxFileSize = 20 * 1024 * 1024;
        this.allowedExtensions = ['pptx', 'pdf', 'jpg', 'png'];
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.syncExistingPresentationFromInput();
        });
    }
    ngOnChanges(changes) {
        if (changes.registerCompanyInfo && !this.selectedFile) {
            this.syncExistingPresentationFromInput();
        }
    }
    syncExistingPresentationFromInput() {
        this.existingPresentationUrl = this.registerCompanyInfo && this.registerCompanyInfo.presentationUrl
            ? this.registerCompanyInfo.presentationUrl
            : null;
        this.existingPresentationFileName = this.registerCompanyInfo && this.registerCompanyInfo.originalPresentationFileName
            ? this.registerCompanyInfo.originalPresentationFileName
            : null;
    }
    get canUploadFile() {
        return !this.selectedFile && !this.existingPresentationFileName;
    }
    get canSavePresentation() {
        return !!this.selectedFile || this.removeExistingPresentation;
    }
    get displayFileName() {
        if (this.selectedFile) {
            return this.selectedFile.name;
        }
        return this.existingPresentationFileName;
    }
    onFileSelected(event) {
        const input = event.target;
        const file = input && input.files && input.files.length > 0 ? input.files[0] : null;
        if (!file) {
            return;
        }
        const extension = this.getFileExtension(file.name);
        if (!this.allowedExtensions.includes(extension)) {
            const uploadError = 'Unsupported file format. Please upload .pptx, .pdf, .jpg, or .png.';
            this.alert.showError(uploadError);
            input.value = '';
            return;
        }
        if (file.size > this.maxFileSize) {
            this.alert.showError(msg.error.uploadFileLarge);
            input.value = '';
            return;
        }
        this.selectedFile = file;
        this.selectedFileChange.emit(file);
        this.existingPresentationFileName = null;
        this.existingPresentationUrl = null;
        input.value = '';
    }
    removeFile() {
        this.selectedFileChange.emit(null);
        this.existingPresentationUrl = null;
        this.existingPresentationFileName = null;
        this.removeExistingPresentation = true;
    }
    downloadFile() {
        if (this.selectedFile) {
            const url = URL.createObjectURL(this.selectedFile);
            const a = document.createElement('a');
            a.href = url;
            a.download = this.selectedFile.name;
            a.click();
            URL.revokeObjectURL(url);
            return;
        }
        if (this.existingPresentationUrl) {
            const a = document.createElement('a');
            a.href = this.existingPresentationUrl;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            if (this.existingPresentationFileName) {
                a.download = this.existingPresentationFileName;
            }
            a.click();
        }
    }
    getFileIconClass(fileName) {
        const extension = this.getFileExtension(fileName);
        if (extension === 'pptx') {
            return 'fas fa-file-powerpoint';
        }
        if (extension === 'pdf') {
            return 'fas fa-file-pdf';
        }
        if (extension === 'jpg' || extension === 'png') {
            return 'fas fa-file-image';
        }
        return 'fas fa-file';
    }
    getFileExtension(fileName) {
        const index = fileName.lastIndexOf('.');
        if (index < 0) {
            return '';
        }
        return fileName.substring(index + 1).toLowerCase();
    }
    onSubmit() {
        if (this.removeExistingPresentation) {
            this.submitPresentation.emit(null);
            this.removeExistingPresentation = false;
            return;
        }
        if (this.selectedFile) {
            this.submitPresentation.emit(this.selectedFile);
            this.removeExistingPresentation = false;
        }
    }
}
